import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import inspectionReducer from "./slice/reportSlice/inspectionSlice";
import authReducer from "./slice/authSlice/index";
import shipReducer from "./slice/shipSlice";

import storage from "redux-persist/lib/storage";

const rootReducer = combineReducers({
    inspection: inspectionReducer,
    auth: authReducer,
    ship: shipReducer,
});

const persistConfig = {
    key: "root",
    storage,
    whitelist: ["ship", "auth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    devTools: import.meta.env.mode !== "production",
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    "persist/PERSIST",
                    "persist/REHYDRATE",
                    "inspection/saveDraft",
                    "inspection/loadDraft",
                ],
            },
        }),
});

const persistor = persistStore(store);
export { store, persistor };
